import { render, staticRenderFns } from "./BankAccountTypes.vue?vue&type=template&id=49a96200&scoped=true&"
import script from "./BankAccountTypes.vue?vue&type=script&lang=js&"
export * from "./BankAccountTypes.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountTypes.vue?vue&type=style&index=0&id=49a96200&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a96200",
  null
  
)

export default component.exports